module.exports = __webpack_public_path__ + "img/Loa-for-laboratory-test.bc1332ac.png";